import {AdminPagingModel} from "./AdminPagingModel";
import {AlertingAction} from "../../entities/AlertingAction";
import {AlertingActionService} from "../../services/AlertingActionService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";

export class AlertingActionAdminPagingModel extends AdminPagingModel<AlertingAction>{
    static $inject = ['$q','AlertingActionService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:AlertingActionService,notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }
    entityName():string{
        return "alertingaction";
    }
    displayName():string{
        return "Alerting Actions";
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs = [['name','Name', null]];
        return this.$q.when();
    }
}
